import React, { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Client Management was replaced by the funnel; old links (API, webhooks, notifications) still point here.
export const getFunnelPathFromClientManagement = (pathname: string, search: string): string => {
  const detailsMatch = pathname.match(/\/details\/(\d+)/);
  if (detailsMatch) return `/funnel/details/${detailsMatch[1]}`;

  const params = new URLSearchParams(search);
  const details = params.get('details');
  const detailsParam = details ? `&details=${details}` : '';

  const chatMatch = pathname.match(/\/chat\/(\d+)/);
  if (chatMatch) return `/funnel?client=${chatMatch[1]}&view=chat${detailsParam}`;
  const clientId = params.get('client');
  if (clientId) return `/funnel?client=${clientId}&view=chat${detailsParam}`;
  return '/funnel';
};

const ClientManagementRedirect: FC = () => {
  const { pathname, search } = useLocation();
  return <Navigate to={getFunnelPathFromClientManagement(pathname, search)} replace />;
};

export default ClientManagementRedirect;
